{
  "actions": "Åtgärder",
  "actionsAvailable": "Åtgärder finns.",
  "clearSelection": "Rensa markering",
  "selected": "{count, plural, =0 {Inga markerade} other {# markerade}}",
  "selectedAll": "Alla markerade"
}
